import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import ContentfulContext from './ContentfulContext';

var ContentfulProvider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ContentfulProvider, _Component);

  function ContentfulProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var client = props.client,
        locale = props.locale,
        renderPromises = props.renderPromises;
    _this.state = {
      client: client,
      locale: locale,
      renderPromises: renderPromises
    };
    return _this;
  }

  var _proto = ContentfulProvider.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        context = _this$props.context;
    var Context = context || ContentfulContext;
    warning(this.state.client, 'No `client` specified on <ContentfulProvider />');
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: this.state
    }, children);
  };

  return ContentfulProvider;
}(Component);

ContentfulProvider.propTypes = {
  children: PropTypes.any,
  client: PropTypes.object.isRequired,
  context: PropTypes.object,
  locale: PropTypes.string,
  renderPromises: PropTypes.object
};
ContentfulProvider.defaultProps = {
  children: null,
  context: null,
  locale: 'en-US',
  renderPromises: null
};
export default ContentfulProvider;